module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_vm._m(0), _vm._v(" "), (_vm.text != null) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text[_vm.currentLanguage])
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "src": "/assets/ceo/logo_hotel.png",
      "height": "60",
      "alt": "Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-492feab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Description.vue
// module id = 365
// module chunks = 0